<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
      <div v-else class="col_12">
        <h1 class="common_title">Chat Categories</h1>
        <div class="card">
          <div class="card_heading">
            <div class="add_item_cat link m15 ">
              <span v-if="!showForm" class="add_new_cat_open pointer" @click.prevent="addNewCategory">+ Add a New Category</span>
              <span class="ml_10">Click Category From List To Edit.</span>
            </div>
          </div>
          <div class="card_body">
            <h4 class="item_cat_heading mb_20">
              Drag & drop to sort.
            </h4>
            <div class="item_short_wrap">
              <nested-draggable
                  v-if="categories.length > 0"
                  :categories="categories"
                  :child="child"
                  @update-prop-value="updatePropValue"
                  @editCategory="editCategory" @changeSort="changeSort"
              />

              <div v-show="showForm" class="add_new_cat pl_15">
                <div class="add_new_inner">
                  <div class="float_right">
                    <span class="close_icon item_cat_close" @click.prevent="closeAddEdit"></span>
                  </div>
                  <h4 class="item_cat_heading mb_20">{{ newForm ? 'Add New' : 'Edit' }} Category</h4>
                  <div class="add_new_cat_form">
                    <div :class="['form_row_inline', {'has_error': errorFor('status')}]">
                      <label class="required">Status</label>
                      <div class="form_radio">
                        <input type="radio" id="statusActive" v-model="form.status" value="1">
                        <label for="statusActive">Active</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="statusInactive" v-model="form.status" value="0">
                        <label for="statusInactive">Inactive</label>
                      </div>
                      <v-errors :errors="errorFor('status')"></v-errors>
                    </div>
                    <div :class="['form_row_inline', {'has_error': errorFor('name')}]">
                      <label class="">Category Name</label>
                      <div class="form_input">
                        <input type="text" class="form_global" name="name" v-model="form.name">
                      </div>
                      <v-errors :errors="errorFor('name')"></v-errors>
                    </div>
                    <div :class="['form_row_inline', {'has_error': errorFor('parent')}]">
                      <label class="">Parent Category</label>
                      <div class="form_input">
                      <select class="form_global" v-model="form.parent">
                        <option value="">Select Parent</option>
                        <option v-for="(category, index) in categoryList" :key="'category' + index"
                                :value="category.id">{{ category.name }}
                        </option>
                      </select>
                      </div>
                      <v-errors :errors="errorFor('parent')"></v-errors>
                    </div>
                    <div class="text_right m15">
                      <div class="display_inline mr_0">
                        <button class="btn btn_danger mr_10 min_width_100p" v-if="!newForm && category"
                                @click.prevent="deleteRecord(category)">Delete
                        </button>
                        <button class="btn btn_primary min_width_100p" @click.prevent="submit">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nestedDraggable from "./NestedCategory";
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

export default {
  name: 'categories',
  components: {LoaderMaskComponent, nestedDraggable},
  data() {
    return {
      lyLoading: false,
      showForm: false,
      newForm: true,
      firstLoad: false,
      form: {
        status: 1,
        name: '',
        parent: '',
      },
      categoryList: [],
      categories: [],
      subCategories: [],
      category: null,
      child: false
    }
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    closeAddEdit(){
      this.showForm = false
      this.allErrors = null;
    },
    updatePropValue() {
      this.child = !this.child;
    },
    changeSort(categories) {
      this.axios.post('/chat-categories/sort', {categories: categories})
          .then(() => {
            this.showSuccessMsg('Category Sort Updated!')
          })
    },
    addNewCategory() {
      this.resetForm();
      this.newForm = true;
      this.showForm = true
    },
    resetForm() {
      this.form = {
        status: 1,
        name: '',
        parent: '',
      }
    },
    editCategory(category) {
      this.resetForm();
      this.categoryList = this.categories
      this.axios.get(`/chat-categories/${category.id}`)
          .then((response) => {
            let data = response.data.data

            if (data.parent && data.parent_category.parent) {
              category.parent = data.parent_category.parent
            } else {
              category.parent = data.parent
            }
          })
      this.categoryList = window._.filter(this.categoryList, (c) => c.id !== category.id)
      this.category = category
      this.form = category
      this.newForm = false;
      this.showForm = true;
    },
    loadData() {
      this.lyLoading = true;
      this.axios.get('/chat-categories', {
        params: {
          sort: 'sort',
          sort_order: 'asc'
        }
      }).then((response) => {
        this.categories = response.data.data
        this.categoryList = response.data.data
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    submit() {
      this.errors = null;
      this.lyLoading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        const value = this.form[key] === 0 ? 0 : (this.form[key] ? this.form[key] : '');
        formData.append(key, value);
      });

      if (this.newForm) {
        this.axios.post('/chat-categories', formData)
            .then(() => {
              this.showForm = false;
              this.showSuccessMsg('Successfully Saved!')
              this.loadData();
              this.resetForm()
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors
            })
            .finally(() => {
              this.lyLoading = false;
            })
      } else {
        formData.append('_method', 'PATCH')

        this.axios.post('/chat-categories/' + this.form.id, formData)
            .then(() => {
              this.showForm = false;
              this.showSuccessMsg('Successfully Saved!')
              this.loadData();
              this.resetForm()
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors
            })
            .finally(() => {
              this.lyLoading = false;
            })
      }
    },
    deleteRecord(category) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/chat-categories/' + category.id).then(() => {
            this.category = null
            this.showForm = false
            this.allErrors = null;
            this.$swal.fire(
                'Deleted',
                'Category has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.opacity_remove {
  opacity: 0;
}

.d_block {
  display: block;
}
</style>